import jsonic from "jsonic";
import jsonspc from "json-stringify-pretty-compact";

export default class Aux
{
	static transformations = [
		{ unsafe: "@", safe: "__AT__", regexUnsafe: /@/g, regexSafe: /__AT__/g },
		{ unsafe: "/", safe: "__FWS__", regexUnsafe: /\//g, regexSafe: /__FWS__/g },
		{ unsafe: ".", safe: "__DOT__", regexUnsafe: /\./g, regexSafe: /__DOT__/g }
	];

	static makeStringsSafeAgain(s: string): string
	{
		this.transformations.forEach(i =>
		{
			s = s.replace(i.regexUnsafe, i.safe);
		});

		return s;
	}

	static makeStringsUnsafeAgain(s: string): string
	{
		this.transformations.forEach(i =>
		{
			s = s.replace(i.regexSafe, i.unsafe);
		});

		return s;
	}

	static makeObjectsSafeAgain(o: object): object
	{
		let r = {};

		for (let key in o)
		{
			const keySafe = this.makeStringsSafeAgain(key);
			const valueSafe = (o as any)[key];

			// TODO: TAC: implement better approach for wrapping "contents" property
			valueSafe.contents = jsonspc(valueSafe.contents);

			(r as any)[keySafe] = valueSafe;
		}

		return r;
	}

	static makeObjectsUnsafeAgain(o: object): object
	{
		console.log("O", o);

		let r = {};

		for (let key in o)
		{
			const keyUnsafe = this.makeStringsUnsafeAgain(key);
			const valueUnsafe = (o as any)[key];

			// TODO: TAC: implement better approach for unwrapping "contents" property
			valueUnsafe.contents = jsonic(valueUnsafe.contents);

			(r as any)[keyUnsafe] = valueUnsafe;
		}

		return r;
	}

	static extractLocales(files: object): string[]
	{
		let locales: string[] = [];

		for (let key in files)
		{
			const fileContents = (files as any)[key].contents;
			const fileContentsLocales = Object.keys(fileContents);

			locales = locales.concat(fileContentsLocales);
		}

		return [... new Set(locales)];
	}
}
